import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

class ProductEntryDetails extends HTMLElement {
  connectedCallback() {
    this.eventTarget = this.closest('.shopify-section, dialog');
    this.eventTarget?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.eventTarget?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  /**
   * Refresh entry and multiplier metafields when the selected variant changes.
   * @param {ProductSelectEvent} event
   */
  handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const selector = `product-entry-details[data-block-id="${this.dataset.blockId}"]`;
        const nextEntryDetails = detail.html.querySelector(selector);
        if (!nextEntryDetails) return;

        morph(this, nextEntryDetails, { childrenOnly: true });
        this.toggleAttribute('hidden', nextEntryDetails.hasAttribute('hidden'));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[product-entry-details] Event promise rejected:', error);
        }
      });
  };
}

if (!customElements.get('product-entry-details')) {
  customElements.define('product-entry-details', ProductEntryDetails);
}
